module.exports = __webpack_public_path__ + "28c20c46923d84c8bc5abc3004faf9df.svg";